export enum NodeTypes {
  GrandMasterKey = "Grand Master Key",
  MasterKey = "Master Key",
  LockSet = "Lock Set",
}